/*
 * @Author: Roman
 * @Date: 2022-11-21 09:36:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-03-28 14:19:41
 * @FilePath: \qpmn-site\src\app\modules\catalog\product-catalog\rest\product-catalog-rest.config.ts
 * @Description: 
 */
import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let ProductCatalogRestServiceConfig: IRestfulConfigMap = {
    "productCatalogRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            getAll:{
                method: "get",
                path: "api/productCatalogs",
                testPath:"api/productCatalogs",
            },
            getDefaultCatalog: {
                method: "get",
                path: "/api/config/default/productCategory/release",
                testPath: "/api/config/default/productCategory/test"
            }
        }
    }
}

export {ProductCatalogRestServiceConfig};